<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
  >
    <template v-slot:item.regions="{ item }">
      {{ getRegionsColumnString(item.regions) }}
    </template>
  </entity-list-table>
</template>

<script>

  import PromoCodeDataService from '@/services/api/PromoCodeDataService'
  import EntityListTable from '@/components/ui/crud/EntityListTable'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Промокоды',
        dataService: PromoCodeDataService,
        createRouteName: 'Новый промокод',
        editRouteName: 'Промокод',

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Код', value: 'code', align: 'start' },
          { text: 'Регионы', value: 'regions', align: 'start' },
          { text: 'Сортировка', value: 'sortOrder', align: 'center' },
          { text: 'Повторное применение', value: 'repeat', align: 'center', type: 'boolean-check' },
        ],

        allowDelete: true,
        showStatusColumn: true,
      }
    },
    computed: {
      ...mapGetters({
        getTimezoneTitle: 'app/getTimezoneTitle',
      }),
    },
    methods: {
      getRegionsColumnString (regions) {
        if (_.isEmpty(regions)) {
          return ''
        }

        return regions.map((item) => item.name).join(', ')
      },
    },
  }
</script>
